import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Dashboard/Home";
import Support from "./pages/Dashboard/Support";
import Custompc from "./pages/Custompc";
import PrebuildPC from "./pages/Prebuildpc/Prebuildpc";
import PCReveal from "./pages/test/PCReveal";
import "./App.css";
import Dashboard from "./admin/pages/dashboard/Dashboard";
import ComponentMaster from "./admin/pages/masters/components/Component";
import Prebuild from "./admin/pages/masters/prebuild/Prebuild";
import CustomPC from "./admin/pages/masters/custompc/Custompc";
import Product from "./admin/pages/masters/products/Product";
import Order from "./admin/pages/orders/Order";
import AdHeader from "./admin/layout/header/AdHeader";
import Login from "./components/login/Login";
import ProtectedRoute from "./components/login/ProtectedRoute";

import Test from "./admin/Test";

function AppRoutes() {
  const location = useLocation();
   const path = location.pathname;
 const isAdmin = path.startsWith("/admin");

  return (
    <>
     {/* <Header /> */}
   <>
          {isAdmin ? <AdHeader /> : <Header />}
        </>

      <Routes>
        {/* Public Routes */}
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/" element={<Test />} />
        <Route path="/custom" element={<Custompc />} />
        <Route path="/prebuilt" element={<PrebuildPC />} />
        <Route path="/support" element={<Support />} />
        <Route path="/login" element={<Login/>} />
        {/* <Route path="/test" element={<AdHeader/>} /> */}

        {/* Admin pages */}
       
        <Route path="/admin/dashboard" element={ <ProtectedRoute> <Dashboard /> </ProtectedRoute> } />
        <Route path="/admin/product" element={ <ProtectedRoute> <Product /> </ProtectedRoute> } />
        <Route path="/admin/prebuild" element={ <ProtectedRoute> <Prebuild /> </ProtectedRoute> } />
        <Route path="/admin/component" element={ <ProtectedRoute> <ComponentMaster /> </ProtectedRoute> } />
        <Route path="/admin/custompc" element={ <ProtectedRoute> <CustomPC /> </ProtectedRoute> } />
        <Route path="/admin/order" element={ <ProtectedRoute> <Order /> </ProtectedRoute> } />
        
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
